import React, { useState } from "react";
import { Box, Button, Typography, Paper } from "@mui/material";

interface OrderMode {
  id: string;
  label: string;
  description: string;
}

const ORDER_MODES: OrderMode[] = [
  {
    id: "dine_in",
    label: "Dine-in",
    description: "Customer will dine in the resturant",
  },
  {
    id: "takeaway",
    label: "Takeaway",
    description: "Customer will take food to go",
  },
  {
    id: "delivery",
    label: "Delivery",
    description: "Customer wants the food to be delivered ",
  },
];

interface OrderModeSelectorProps {
  onSelect: (mode: string) => void;
  currentMode?: string | null;
}

export const OrderModeSelector: React.FC<OrderModeSelectorProps> = ({
  onSelect,
  currentMode,
}) => {
  const [selectedMode, setSelectedMode] = useState<string | null>(
    currentMode || null
  );
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSelect = (mode: string) => {
    if (selectedMode && selectedMode !== mode) {
      setShowConfirm(true);
    } else {
      setSelectedMode(mode);
      onSelect(mode);
    }
  };

  const confirmChange = () => {
    setSelectedMode(null);
    setShowConfirm(false);
  };

  return (
    <Box sx={{ p: 3 }}>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 3 }}>
        {ORDER_MODES.map((mode) => (
          <Paper
            key={mode.id}
            elevation={1}
            onClick={() => handleSelect(mode.id)}
            sx={{
              p: 2,
              cursor: "pointer",
              border:
                selectedMode === mode.id
                  ? "2px solid #1E8078"
                  : "1px solid #ccc",
              backgroundColor:
                selectedMode === mode.id
                  ? "#e6f9f7"
                  : "background.paper",
              transition: "all 0.2s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: 4,
              },
            }}
          >
            <Typography variant="h6">{mode.label}</Typography>
            <Typography variant="body2" color="text.secondary">
              {mode.description}
            </Typography>
          </Paper>
        ))}
      </Box>

      {/* Confirmation Modal */}
      {showConfirm && (
        <Box
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            p: 3,
            borderRadius: 2,
            boxShadow: 24,
            zIndex: 1000,
            width: 300,
            textAlign: "center",
          }}
        >
          <Typography gutterBottom>
            Switching mode will reset your current order. Are you sure?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={() => setShowConfirm(false)} size="small">
              Cancel
            </Button>
            <Button
              onClick={confirmChange}
              variant="contained"
              size="small"
              color="primary"
            >
              Confirm
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};